import { ChevronUp } from "lucide-react";
import { Button, Props as ButtonProps } from "./Button";
import { Dropdown } from "./Dropdown";

export type Props = ButtonProps & {
  buttonIcon: React.ComponentType<{ className?: string }>;
  buttonLabel: string;
  buttonOnClick: () => void;
  dropdownOptions: React.ReactNode[];
  destructive?: boolean;
  disabled?: boolean;
};

export const ButtonDropdownCombo = ({
  buttonIcon,
  buttonLabel,
  buttonOnClick,
  dropdownOptions,
  destructive,
  disabled = false,
}: Props) => {
  return (
    <div className="flex items-center">
      <Button
        iconComponent={buttonIcon}
        onClick={buttonOnClick}
        variant="ghost"
        theme="dark"
        destructive={destructive}
        disabled={disabled}
      >
        {buttonLabel}
      </Button>

      {dropdownOptions && dropdownOptions.length > 0 && !disabled && (
        <Dropdown
          trigger={
            <Button iconComponent={ChevronUp} variant="ghost" theme="dark" />
          }
        >
          <div className="flex flex-col max-h-[600px] overflow-y-auto">
            {dropdownOptions && dropdownOptions.map((option) => option)}
          </div>
        </Dropdown>
      )}
    </div>
  );
};
